import { render } from "./Page500.vue?vue&type=template&id=90475b94"
import script from "./Page500.vue?vue&type=script&lang=js"
export * from "./Page500.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__